import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class CustomProfilePage extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "content", Model.attribute('content'));
    _defineProperty(this, "contentHtml", Model.attribute('contentHtml'));
    _defineProperty(this, "userId", Model.attribute('userId'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "updatedAt", Model.attribute('updatedAt', Model.transformDate));
    _defineProperty(this, "user", Model.hasOne('user'));
  }
}
flarum.reg.add('huseyinfiliz-custom-profile-page', 'forum/models/CustomProfilePage', CustomProfilePage);